import React, { useEffect } from 'react';
import { Container, Row, Col, Image } from "react-bootstrap";
import expert1 from "../../../assets/images/resource/expert1.png"
import AOS from "aos";
import { ExpertsJson } from './ExpertsJson';
const Experts = () => {
    useEffect(() => {
        AOS.init({ duration: 2000, },);
    }, [])
    return (
        <>
            <section className='experts_wrap'>
                <div className='experts_text_wrap'>
                    <div className='experts_text_title' data-aos='fade-down'>
                        <h1>A team of 40+ experts</h1>
                        <p>From fitness, life and wellness coaches, award-winning speakers, thought leaders, elite athletes and many more, the majority of us used to work in the corporate world and this is why we can resonate with your employees’ greatest aspirations and challenges.</p>
                    </div>
                </div>
                <div className='experts_card_wrap'>
                    <Container fluid>
                        <Row>
                            {
                                ExpertsJson.map((event, index) => {
                                    return (
                                        <Col sm={6} md={4} lg={4} xl={3} key={index}>
                                            <div className='experts_card'>
                                                <figure className='experts_img'>
                                                    <Image src={event.image} alt="experts" fluid />
                                                </figure>
                                                <article className='experts_article'>
                                                    <h4>{event.name}</h4>
                                                    <p>{event.details}</p>
                                                </article>
                                            </div>
                                        </Col>
                                    )
                                })
                            }
                        </Row>
                    </Container>
                </div>
            </section>
        </>
    )
}

export default Experts